
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3ePvn", function(module, exports) {
var $61d8c334831b33b2$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $61d8c334831b33b2$export$45e63649edff1e2a = 'ASSETS';
const $61d8c334831b33b2$export$45c80c6b98d65f36 = 3;
const $61d8c334831b33b2$export$7b4183e5f0de390a = 1000;
const $61d8c334831b33b2$export$2edbfcb69dc77e78 = 1;
const $61d8c334831b33b2$export$891dc7068a3d5e65 = 14;
const $61d8c334831b33b2$export$6e594fe130dbe3b = 14;
var $61d8c334831b33b2$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $61d8c334831b33b2$export$c889532d47d74e9c = 'bff';
const $61d8c334831b33b2$export$123b1b8742c0ac6a = 'flightdeck';
const $61d8c334831b33b2$export$1631e8a201b50246 = 'uc-menu-items';
module.exports["BFFConsumerEnum"] = $61d8c334831b33b2$export$9a146e025690327e;
module.exports["ASSETS_APP_KEY"] = $61d8c334831b33b2$export$45e63649edff1e2a;
module.exports["RETRY_INTERVAL_DEFAULT"] = $61d8c334831b33b2$export$7b4183e5f0de390a;
module.exports["MAX_ATTEMPTS_NEW_DEFAULT"] = $61d8c334831b33b2$export$2edbfcb69dc77e78;
module.exports["RequestStatus"] = $61d8c334831b33b2$export$600e7c1f9e0414e1;
module.exports["BFF_REQUEST_STATUS_KEY"] = $61d8c334831b33b2$export$c889532d47d74e9c;
module.exports["FLIGHTDECK_REQUEST_STATUS_KEY"] = $61d8c334831b33b2$export$123b1b8742c0ac6a;
module.exports["UC_MENU_ITEMS_REQUEST_STATUS_KEY"] = $61d8c334831b33b2$export$1631e8a201b50246;

});

parcelRegister("iBJls", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");

const $11aafb4b171e622f$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $11aafb4b171e622f$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $cozmU.createContext)({
    value: $11aafb4b171e622f$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: ()=>{}
});
const $11aafb4b171e622f$export$63342c357ecccda2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBFFContext() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($11aafb4b171e622f$export$873dcaf380a86d6b);
} : function useBFFContext() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($11aafb4b171e622f$export$873dcaf380a86d6b);
};
const $11aafb4b171e622f$export$71a938590b6955cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BFFProvider(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { consumer: consumer, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== consumer) {
        t2 = {
            cache: t1,
            cacheKey: consumer,
            consumer: consumer,
            status: (0, $3ePvn.RequestStatus).INIT
        };
        $[1] = consumer;
        $[2] = t2;
    } else t2 = $[2];
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[3] = t3;
    } else t3 = $[3];
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (name, status)=>{
            bb2: switch(status){
                case (0, $3ePvn.RequestStatus).LOADING:
                    setCurrentLoadingRequests((prev_0)=>[
                            ...prev_0,
                            name
                        ]);
                    break bb2;
                case (0, $3ePvn.RequestStatus).COMPLETE:
                    setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                    break bb2;
                case (0, $3ePvn.RequestStatus).ERROR:
                    setCurrentLoadingRequests([]);
            }
        };
        $[4] = t4;
    } else t4 = $[4];
    const updateCurrentLoadingRequests = t4;
    let t5;
    if ($[5] !== currentLoadingRequests || $[6] !== value) {
        t5 = {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        };
        $[5] = currentLoadingRequests;
        $[6] = value;
        $[7] = t5;
    } else t5 = $[7];
    const stableContextValue = t5;
    let t6;
    if ($[8] !== children || $[9] !== stableContextValue) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11aafb4b171e622f$export$873dcaf380a86d6b.Provider, {
            value: stableContextValue
        }, children);
        $[8] = children;
        $[9] = stableContextValue;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : function BFFProvider({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $3ePvn.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState([]);
    const updateCurrentLoadingRequests = (0, $cozmU.useCallback)((name, status)=>{
        switch(status){
            case (0, $3ePvn.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev_0)=>[
                        ...prev_0,
                        name
                    ]);
                break;
            case (0, $3ePvn.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $3ePvn.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    const stableContextValue = (0, $cozmU.useMemo)(()=>({
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        }), [
        currentLoadingRequests,
        updateCurrentLoadingRequests,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11aafb4b171e622f$export$873dcaf380a86d6b.Provider, {
        value: stableContextValue
    }, children);
};
const $11aafb4b171e622f$var$defaultUserControls = {
    user: undefined
};
const $11aafb4b171e622f$export$38ee920e59704589 = /*#__PURE__*/ (0, $cozmU.createContext)($11aafb4b171e622f$var$defaultUserControls);
const $11aafb4b171e622f$export$87c54b525b914dab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUserContext() {
    return (0, $cozmU.useContext)($11aafb4b171e622f$export$38ee920e59704589);
} : function useUserContext() {
    return (0, $cozmU.useContext)($11aafb4b171e622f$export$38ee920e59704589);
};
module.exports["BFFContext"] = $11aafb4b171e622f$export$873dcaf380a86d6b;
module.exports["useBFFContext"] = $11aafb4b171e622f$export$63342c357ecccda2;
module.exports["BFFProvider"] = $11aafb4b171e622f$export$71a938590b6955cc;
module.exports["useUserContext"] = $11aafb4b171e622f$export$87c54b525b914dab;

});

parcelRegister("cN3xQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4fwrR = parcelRequire("4fwrR");


var $hZrbV = parcelRequire("hZrbV");


var $lh3Ec = parcelRequire("lh3Ec");

const $b1867ebd3a377ce5$export$335b0c12ccf77339 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavBoundaryContext(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { location: t1, disableSentry: t2, disableAnalytics: t3, onError: onError, sentryConfig: sentryConfig, tags: tags } = t0 === undefined ? {} : t0;
    const location = t1 === undefined ? "unknown" : t1;
    const disableSentry = t2 === undefined ? false : t2;
    const disableAnalytics = t3 === undefined ? false : t3;
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $hZrbV.setupSentryClient)({
            sentryConfig: sentryConfig
        });
    } catch (t4) {
        const error = t4;
        fireEvent("operational.initSentry.failed", {
            location: location,
            reason: error instanceof Error ? error.message : "unknown"
        });
    }
    sentryConfig?.product;
    const t4 = sentryConfig?.product ?? (0, $lh3Ec.SENTRY_PRODUCT);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = $b1867ebd3a377ce5$var$getProductBuild();
        $[0] = t5;
    } else t5 = $[0];
    let t6;
    if ($[1] !== location || $[2] !== t4 || $[3] !== tags) {
        t6 = {
            ...tags,
            location: location,
            teamName: (0, $lh3Ec.SENTRY_TEAM_NAME),
            product: t4,
            productBuild: t5
        };
        $[1] = location;
        $[2] = t4;
        $[3] = tags;
        $[4] = t6;
    } else t6 = $[4];
    const tagsToLog = t6;
    let t7;
    if ($[5] !== disableAnalytics || $[6] !== disableSentry || $[7] !== fireEvent || $[8] !== location || $[9] !== onError || $[10] !== tagsToLog) {
        t7 = (error_0)=>{
            if (!disableSentry) try {
                (0, $hZrbV.logException)(error_0, tagsToLog);
            } catch (t8) {
                const err = t8;
                fireEvent("operational.logToSentry.failed", {
                    location: location,
                    reason: err instanceof Error ? err.message : "unknown"
                });
            }
            if (!disableAnalytics) fireEvent("operational.errorBoundary.unhandledErrorCaught", {
                location: location,
                errorMessage: error_0.message,
                errorStack: error_0.stack || "no stack trace"
            });
            onError?.(error_0);
        };
        $[5] = disableAnalytics;
        $[6] = disableSentry;
        $[7] = fireEvent;
        $[8] = location;
        $[9] = onError;
        $[10] = tagsToLog;
        $[11] = t7;
    } else t7 = $[11];
    const handleError = t7;
    let t8;
    if ($[12] !== handleError) {
        t8 = {
            handleError: handleError
        };
        $[12] = handleError;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : function useNavBoundaryContext({ location: location = 'unknown', disableSentry: disableSentry = false, disableAnalytics: disableAnalytics = false, onError: onError, sentryConfig: sentryConfig, tags: tags } = {}) {
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $hZrbV.setupSentryClient)({
            sentryConfig: sentryConfig
        });
    } catch (error) {
        // Log failure to initialize Sentry
        fireEvent('operational.initSentry.failed', {
            location: location,
            reason: error instanceof Error ? error.message : 'unknown'
        });
    }
    const tagsToLog = (0, $cozmU.useMemo)(()=>{
        return {
            ...tags,
            location: location,
            teamName: (0, $lh3Ec.SENTRY_TEAM_NAME),
            product: sentryConfig?.product ?? (0, $lh3Ec.SENTRY_PRODUCT),
            productBuild: $b1867ebd3a377ce5$var$getProductBuild()
        };
    }, [
        tags,
        location,
        sentryConfig?.product
    ]);
    const handleError = (0, $cozmU.useCallback)((error_0)=>{
        // Send events to sentry
        if (!disableSentry) try {
            (0, $hZrbV.logException)(error_0, tagsToLog);
        } catch (err) {
            // Log failure to send to Sentry
            fireEvent('operational.logToSentry.failed', {
                location: location,
                reason: err instanceof Error ? err.message : 'unknown'
            });
        }
        // Fire Analytics event
        if (!disableAnalytics) fireEvent('operational.errorBoundary.unhandledErrorCaught', {
            location: location,
            errorMessage: error_0.message,
            errorStack: error_0.stack || 'no stack trace'
        });
        // Invoke external onError
        onError?.(error_0);
    }, [
        disableSentry,
        disableAnalytics,
        onError,
        location,
        tagsToLog,
        fireEvent
    ]);
    return {
        handleError: handleError
    };
};
function $b1867ebd3a377ce5$var$getProductBuild() {
    // Ensure we don't invoke window object in SSR
    if (typeof window === 'undefined') return 'unknown';
    switch(true){
        // Jira - window.BUILD_KEY
        case 'BUILD_KEY' in window:
            return window.BUILD_KEY || 'unknown';
        // Confluence - window.__buildInfo
        case '__buildInfo' in window:
            return window.__buildInfo?.FRONTEND_VERSION || 'unknown';
        default:
            return 'unknown';
    }
}
module.exports["useNavBoundaryContext"] = $b1867ebd3a377ce5$export$335b0c12ccf77339;

});

parcelRegister("4fwrR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9O4vJ = parcelRequire("9O4vJ");


var $834sd = parcelRequire("834sd");

const $30cfe5bdec878b29$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $834sd.default)(...params));
            event.fire((0, $9O4vJ.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $834sd.default)(...params));
        event.fire((0, $9O4vJ.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $30cfe5bdec878b29$export$5bf35293e545f20c;

});

parcelRegister("9O4vJ", function(module, exports) {
const $8d3a8f742341084f$export$3f072f06b90c3985 = 'navigation';
module.exports["EVENT_CHANNEL"] = $8d3a8f742341084f$export$3f072f06b90c3985;

});

parcelRegister("834sd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::dc0a1bceb2402ac8e42ce6b49bcb524d>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen navigation-error-boundary
 */ const $263f41c0f74fa853$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $263f41c0f74fa853$export$2e2bcd8739ae039 = $263f41c0f74fa853$var$createEventPayload;
module.exports["default"] = $263f41c0f74fa853$export$2e2bcd8739ae039;

});

parcelRegister("hZrbV", function(module, exports) {

var $3DrBT = parcelRequire("3DrBT");

var $hgJ38 = parcelRequire("hgJ38");

var $6PuLb = parcelRequire("6PuLb");

var $7tbUV = parcelRequire("7tbUV");

var $kzeX8 = parcelRequire("kzeX8");


var $5D2Vi = parcelRequire("5D2Vi");


var $cuWGz = parcelRequire("cuWGz");


var $lh3Ec = parcelRequire("lh3Ec");

let $f99dbbf2ed634000$var$sentryClient;
let $f99dbbf2ed634000$var$activeSuppressBackendErrors;
let $f99dbbf2ed634000$var$scope = new (0, $kzeX8.Scope)();
/** Reads `name` / `message` off an Error or a normalised plain-object error, if present. */ function $f99dbbf2ed634000$var$toErrorLike(value) {
    if (typeof value !== 'object' || value === null) return {};
    const { name: name, message: message } = value;
    return {
        name: typeof name === 'string' ? name : undefined,
        message: typeof message === 'string' ? message : undefined
    };
}
function $f99dbbf2ed634000$var$isBFFErrorName(name) {
    return name === (0, $5D2Vi.BFFErrorEnum).BFF_ERROR || name === (0, $5D2Vi.BFFErrorEnum).BFF_NETWORK_ERROR;
}
/** Parses a BFF `status` extra into an HTTP status code. Non-status values (e.g. "error") are ignored. */ function $f99dbbf2ed634000$var$parseHttpStatus(status) {
    if (typeof status === 'number') return Number.isInteger(status) ? status : undefined;
    if (typeof status === 'string' && /^\d{3}$/.test(status.trim())) return Number(status);
    return undefined;
}
/** Joins `type` and `value` the same way Sentry's `ignoreErrors` filter does. */ function $f99dbbf2ed634000$var$withType(type, value) {
    return type && value ? `${type}: ${value}` : undefined;
}
function $f99dbbf2ed634000$export$ad536eaf3aa9a746(event) {
    const extras = event.extra ?? {};
    // Sentry chains causes as multiple `values`. Older events have a single value, newer linked
    // errors can have several — classify as suppress if any of them is a known transport failure.
    const exceptions = event.exception?.values ?? [];
    const original = $f99dbbf2ed634000$var$toErrorLike(extras.originalError);
    const candidates = [
        event.message,
        ...exceptions.flatMap((e)=>[
                e.value,
                $f99dbbf2ed634000$var$withType(e.type, e.value)
            ]),
        original.message,
        $f99dbbf2ed634000$var$withType(original.name, original.message)
    ].filter((candidate)=>Boolean(candidate));
    if ((0, $lh3Ec.SUPPRESSED_BACKEND_ERROR_PATTERNS).some((re)=>candidates.some((c)=>re.test(c)))) return 'suppress';
    // Prefer the explicit status on BFF wrappers; fall back to the `fetchJSON` message format on
    // the wrapped original error. The outer exception value and `event.message` are usually
    // derived from the same `fetchJSON` message for status-bearing errors, so these last two
    // parses are defensive fallbacks for non-wrapped errors or future error shapes.
    const httpStatus = ($f99dbbf2ed634000$var$isBFFErrorName(extras.name) ? $f99dbbf2ed634000$var$parseHttpStatus(extras.status) : undefined) ?? (0, $lh3Ec.extractHttpStatusFromMessage)(original.message) ?? (0, $lh3Ec.extractHttpStatusFromMessage)(exceptions[exceptions.length - 1]?.value) ?? (0, $lh3Ec.extractHttpStatusFromMessage)(event.message);
    return (0, $lh3Ec.classifyHttpStatus)(httpStatus);
}
function $f99dbbf2ed634000$export$ef31311040ebdb46(event) {
    return $f99dbbf2ed634000$export$ad536eaf3aa9a746(event) === 'suppress';
}
function $f99dbbf2ed634000$export$8b38ee55852dc5a(event, random = Math.random) {
    switch($f99dbbf2ed634000$export$ad536eaf3aa9a746(event)){
        case 'suppress':
            return null;
        case 'sample':
            if (random() >= (0, $lh3Ec.RATE_LIMITED_SAMPLE_RATE)) return null;
            return {
                ...event,
                tags: {
                    ...event.tags,
                    suppressionSampleRate: String((0, $lh3Ec.RATE_LIMITED_SAMPLE_RATE))
                }
            };
        default:
            return event;
    }
}
function $f99dbbf2ed634000$export$f86b2a1a2ce291b3(exception, tags) {
    $f99dbbf2ed634000$var$scope.setTags(tags);
    if (exception instanceof (0, $5D2Vi.BFFError)) {
        const error = exception;
        $f99dbbf2ed634000$var$scope.setExtras({
            name: error.name,
            context: error.context,
            status: error.status,
            timestamp: error.timestamp,
            originalError: error.originalError,
            ...error instanceof (0, $5D2Vi.BFFNetworkError) && {
                url: error.url
            }
        });
    }
    $f99dbbf2ed634000$var$sentryClient?.captureException(exception, undefined, $f99dbbf2ed634000$var$scope);
    // Unset tags to prevent an instance of the error boundary from logging with a specific tag,
    // and then another instance from wrongly passing it despite not having the tag.
    for (const [key, _] of Object.entries(tags))$f99dbbf2ed634000$var$scope.setTag(key, undefined);
    // Unset any extras to prevent them from persisting
    $f99dbbf2ed634000$var$scope.setExtras({});
}
function $f99dbbf2ed634000$export$d8bd0edf6c978788({ sentryConfig: sentryConfig }) {
    const { dsn: dsn = (0, $lh3Ec.SENTRY_DSN), env: env, suppressBackendErrors: suppressBackendErrors = true } = sentryConfig || {};
    if ($f99dbbf2ed634000$var$sentryClient) {
        // Singleton: later callers can't change the suppression behaviour, so warn once if they
        // try. Products should coordinate on this setting at the boundary that initialises first.
        if ($f99dbbf2ed634000$var$activeSuppressBackendErrors !== undefined && $f99dbbf2ed634000$var$activeSuppressBackendErrors !== suppressBackendErrors) // eslint-disable-next-line no-console
        console.warn(`[navigation-error-boundary] setupSentryClient was already initialised with suppressBackendErrors=${$f99dbbf2ed634000$var$activeSuppressBackendErrors}; later value ${suppressBackendErrors} is ignored.`);
        return true;
    }
    // SSR-safe check. If we are in SSR, we don't need a sentryClient
    if (typeof window === 'undefined') return false;
    $f99dbbf2ed634000$var$activeSuppressBackendErrors = suppressBackendErrors;
    const environment = (0, $cuWGz.getEnvironment)(env);
    // filter integrations that use the global variable
    const integrations = (0, $6PuLb.getDefaultIntegrations)({}).filter((defaultIntegration)=>{
        return ![
            'BrowserApiErrors',
            'Breadcrumbs',
            'GlobalHandlers'
        ].includes(defaultIntegration.name);
    });
    $f99dbbf2ed634000$var$sentryClient = new (0, $3DrBT.BrowserClient)({
        ...(0, $lh3Ec.DEFAULT_SENTRY_CONFIG),
        ignoreErrors: suppressBackendErrors ? [
            ...(0, $lh3Ec.DEFAULT_SENTRY_CONFIG).ignoreErrors,
            ...(0, $lh3Ec.SUPPRESSED_BACKEND_ERROR_PATTERNS)
        ] : (0, $lh3Ec.DEFAULT_SENTRY_CONFIG).ignoreErrors,
        dsn: dsn,
        environment: environment,
        beforeSend: (event)=>{
            // Only events captured via logException (which sets teamName)
            if (event.tags?.teamName === undefined) return null;
            return suppressBackendErrors ? $f99dbbf2ed634000$export$8b38ee55852dc5a(event) : event;
        },
        attachStacktrace: true,
        transport: (0, $7tbUV.makeFetchTransport),
        stackParser: (0, $hgJ38.defaultStackParser),
        integrations: integrations
    });
    $f99dbbf2ed634000$var$scope.setClient($f99dbbf2ed634000$var$sentryClient);
    $f99dbbf2ed634000$var$sentryClient.init();
    return true;
}
function $f99dbbf2ed634000$export$64db7b418e82aaf6() {
    $f99dbbf2ed634000$var$sentryClient = undefined;
    $f99dbbf2ed634000$var$activeSuppressBackendErrors = undefined;
    $f99dbbf2ed634000$var$scope = new (0, $kzeX8.Scope)();
}
module.exports["logException"] = $f99dbbf2ed634000$export$f86b2a1a2ce291b3;
module.exports["setupSentryClient"] = $f99dbbf2ed634000$export$d8bd0edf6c978788;

});

parcelRegister("3DrBT", function(module, exports) {

var $8zSYe = parcelRequire("8zSYe");

var $f4dVw = parcelRequire("f4dVw");


var $1A5z7 = parcelRequire("1A5z7");

var $lPueq = parcelRequire("lPueq");

var $7rKTM = parcelRequire("7rKTM");

var $9Yk75 = parcelRequire("9Yk75");


var $2FWlS = parcelRequire("2FWlS");


var $eRIET = parcelRequire("eRIET");


var $hu6SQ = parcelRequire("hu6SQ");


var $dFsqR = parcelRequire("dFsqR");

/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $2a5a6e69bbd83895$export$1df9218a526d318d extends (0, $f4dVw.BaseClient) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $eRIET.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $eRIET.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $dFsqR.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $1A5z7.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $lPueq.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $hu6SQ.WINDOW).SENTRY_SDK_SOURCE || (0, $7rKTM.getSDKSource)();
        (0, $8zSYe.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $hu6SQ.WINDOW).document) (0, $hu6SQ.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $hu6SQ.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
}
module.exports["BrowserClient"] = $2a5a6e69bbd83895$export$1df9218a526d318d;

});

parcelRegister("2FWlS", function(module, exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1f2cac9718387eef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports["DEBUG_BUILD"] = $1f2cac9718387eef$export$16a28057038b10ef;

});

parcelRegister("eRIET", function(module, exports) {

var $21cRg = parcelRequire("21cRg");


var $husV7 = parcelRequire("husV7");

var $fvU8j = parcelRequire("fvU8j");

var $jCulH = parcelRequire("jCulH");

var $c9zD7 = parcelRequire("c9zD7");

var $6WvWU = parcelRequire("6WvWU");

/**
 * This function creates an exception from a JavaScript Error
 */ function $ad28a833a6c5806e$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $ad28a833a6c5806e$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $21cRg.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $jCulH.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $ad28a833a6c5806e$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $c9zD7.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $ad28a833a6c5806e$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $ad28a833a6c5806e$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $ad28a833a6c5806e$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $ad28a833a6c5806e$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($ad28a833a6c5806e$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $ad28a833a6c5806e$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $ad28a833a6c5806e$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $ad28a833a6c5806e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $husV7.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $6WvWU.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $ad28a833a6c5806e$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $6WvWU.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $jCulH.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $jCulH.isDOMError)(exception) || (0, $jCulH.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $jCulH.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $husV7.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $jCulH.isError)(exception)) // we have a real Error object, do nothing
    return $ad28a833a6c5806e$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $jCulH.isPlainObject)(exception) || (0, $jCulH.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $ad28a833a6c5806e$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $husV7.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $husV7.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $husV7.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $ad28a833a6c5806e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $ad28a833a6c5806e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $jCulH.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $ad28a833a6c5806e$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $fvU8j.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $jCulH.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $jCulH.isEvent)(exception)) {
        const className = $ad28a833a6c5806e$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $ad28a833a6c5806e$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
module.exports["exceptionFromError"] = $ad28a833a6c5806e$export$a6c2d27607295951;
module.exports["eventFromException"] = $ad28a833a6c5806e$export$ea3ec7e569b823fc;
module.exports["eventFromUnknownInput"] = $ad28a833a6c5806e$export$9dd56ed1ef0c3420;
module.exports["eventFromMessage"] = $ad28a833a6c5806e$export$5425b53185d13d6c;

});

parcelRegister("hu6SQ", function(module, exports) {


var $21cRg = parcelRequire("21cRg");


var $husV7 = parcelRequire("husV7");

var $fvU8j = parcelRequire("fvU8j");

var $ketRo = parcelRequire("ketRo");

const $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81 = (0, $ketRo.GLOBAL_OBJ);
let $cbaa93f0b0a58b8d$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $cbaa93f0b0a58b8d$export$b79738ab10c590b2() {
    return $cbaa93f0b0a58b8d$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $cbaa93f0b0a58b8d$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $cbaa93f0b0a58b8d$var$ignoreOnError++;
    setTimeout(()=>{
        $cbaa93f0b0a58b8d$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $cbaa93f0b0a58b8d$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $fvU8j.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$cbaa93f0b0a58b8d$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $cbaa93f0b0a58b8d$export$1265a142ff5ba165();
            (0, $21cRg.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $husV7.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $husV7.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $21cRg.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $fvU8j.markFunctionWrapped)(sentryWrapped, fn);
    (0, $fvU8j.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
module.exports["WINDOW"] = $cbaa93f0b0a58b8d$export$56d8a8a25bd48b81;
module.exports["shouldIgnoreOnError"] = $cbaa93f0b0a58b8d$export$b79738ab10c590b2;
module.exports["wrap"] = $cbaa93f0b0a58b8d$export$4997ffc0176396a6;

});

parcelRegister("dFsqR", function(module, exports) {

var $9OC7c = parcelRequire("9OC7c");

var $lPueq = parcelRequire("lPueq");

/**
 * Creates an envelope from a user feedback.
 */ function $02915fa006cb574e$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $lPueq.dsnToString)(dsn)
        }
    };
    const item = $02915fa006cb574e$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $9OC7c.createEnvelope)(headers, [
        item
    ]);
}
function $02915fa006cb574e$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}
module.exports["createUserFeedbackEnvelope"] = $02915fa006cb574e$export$24a4dfcb686ee5bf;

});

parcelRegister("hgJ38", function(module, exports) {

var $akjeV = parcelRequire("akjeV");

// global reference to slice
const $c926e031adfb6ad3$var$UNKNOWN_FUNCTION = '?';
const $c926e031adfb6ad3$var$OPERA10_PRIORITY = 10;
const $c926e031adfb6ad3$var$OPERA11_PRIORITY = 20;
const $c926e031adfb6ad3$var$CHROME_PRIORITY = 30;
const $c926e031adfb6ad3$var$WINJS_PRIORITY = 40;
const $c926e031adfb6ad3$var$GECKO_PRIORITY = 50;
function $c926e031adfb6ad3$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true // All browser frames are considered in_app
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $c926e031adfb6ad3$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $c926e031adfb6ad3$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $c926e031adfb6ad3$var$chromeStackParserFn = (line)=>{
    const parts = $c926e031adfb6ad3$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $c926e031adfb6ad3$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $c926e031adfb6ad3$var$extractSafariExtensionDetails(parts[1] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, parts[2]);
        return $c926e031adfb6ad3$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $c926e031adfb6ad3$export$263a749fff749872 = [
    $c926e031adfb6ad3$var$CHROME_PRIORITY,
    $c926e031adfb6ad3$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $c926e031adfb6ad3$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $c926e031adfb6ad3$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $c926e031adfb6ad3$var$gecko = (line)=>{
    const parts = $c926e031adfb6ad3$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $c926e031adfb6ad3$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION;
        [func, filename] = $c926e031adfb6ad3$var$extractSafariExtensionDetails(func, filename);
        return $c926e031adfb6ad3$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $c926e031adfb6ad3$export$cdba47a5dd2804d = [
    $c926e031adfb6ad3$var$GECKO_PRIORITY,
    $c926e031adfb6ad3$var$gecko
];
const $c926e031adfb6ad3$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $c926e031adfb6ad3$var$winjs = (line)=>{
    const parts = $c926e031adfb6ad3$var$winjsRegex.exec(line);
    return parts ? $c926e031adfb6ad3$var$createFrame(parts[2], parts[1] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $c926e031adfb6ad3$export$179460296da408e8 = [
    $c926e031adfb6ad3$var$WINJS_PRIORITY,
    $c926e031adfb6ad3$var$winjs
];
const $c926e031adfb6ad3$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $c926e031adfb6ad3$var$opera10 = (line)=>{
    const parts = $c926e031adfb6ad3$var$opera10Regex.exec(line);
    return parts ? $c926e031adfb6ad3$var$createFrame(parts[2], parts[3] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $c926e031adfb6ad3$export$f892b52c880ffc7a = [
    $c926e031adfb6ad3$var$OPERA10_PRIORITY,
    $c926e031adfb6ad3$var$opera10
];
const $c926e031adfb6ad3$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $c926e031adfb6ad3$var$opera11 = (line)=>{
    const parts = $c926e031adfb6ad3$var$opera11Regex.exec(line);
    return parts ? $c926e031adfb6ad3$var$createFrame(parts[5], parts[3] || parts[4] || $c926e031adfb6ad3$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $c926e031adfb6ad3$export$af11af13f09fb0dc = [
    $c926e031adfb6ad3$var$OPERA11_PRIORITY,
    $c926e031adfb6ad3$var$opera11
];
const $c926e031adfb6ad3$export$7197c0fe6554c079 = [
    $c926e031adfb6ad3$export$263a749fff749872,
    $c926e031adfb6ad3$export$cdba47a5dd2804d,
    $c926e031adfb6ad3$export$179460296da408e8
];
const $c926e031adfb6ad3$export$2b2b997d81bf3907 = (0, $akjeV.createStackParser)(...$c926e031adfb6ad3$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $c926e031adfb6ad3$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $c926e031adfb6ad3$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};
module.exports["defaultStackParser"] = $c926e031adfb6ad3$export$2b2b997d81bf3907;

});

parcelRegister("6PuLb", function(module, exports) {

var $21cRg = parcelRequire("21cRg");

var $lzqTp = parcelRequire("lzqTp");

var $duU2C = parcelRequire("duU2C");

var $fWjB8 = parcelRequire("fWjB8");

var $6Svx4 = parcelRequire("6Svx4");

var $8e57t = parcelRequire("8e57t");

var $AcsET = parcelRequire("AcsET");


var $jYHGu = parcelRequire("jYHGu");

var $9Yk75 = parcelRequire("9Yk75");

var $akjeV = parcelRequire("akjeV");

var $k6sEr = parcelRequire("k6sEr");


var $3DrBT = parcelRequire("3DrBT");


var $2FWlS = parcelRequire("2FWlS");


var $hu6SQ = parcelRequire("hu6SQ");


var $1rIoQ = parcelRequire("1rIoQ");


var $9sZl8 = parcelRequire("9sZl8");


var $hoz89 = parcelRequire("hoz89");


var $6UVdi = parcelRequire("6UVdi");


var $2XbcD = parcelRequire("2XbcD");


var $crxqs = parcelRequire("crxqs");


var $hgJ38 = parcelRequire("hgJ38");


var $7tbUV = parcelRequire("7tbUV");


var $jaNts = parcelRequire("jaNts");

/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $4f8f5dca3b792261$export$5ef831fccfce35e5 = [
    (0, $8e57t.inboundFiltersIntegration)(),
    (0, $lzqTp.functionToStringIntegration)(),
    (0, $crxqs.browserApiErrorsIntegration)(),
    (0, $1rIoQ.breadcrumbsIntegration)(),
    (0, $hoz89.globalHandlersIntegration)(),
    (0, $2XbcD.linkedErrorsIntegration)(),
    (0, $9sZl8.dedupeIntegration)(),
    (0, $6UVdi.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $4f8f5dca3b792261$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$4f8f5dca3b792261$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4f8f5dca3b792261$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4f8f5dca3b792261$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $hu6SQ.WINDOW).SENTRY_RELEASE && (0, $hu6SQ.WINDOW).SENTRY_RELEASE.id) options.release = (0, $hu6SQ.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $akjeV.stackParserFromStackParserOptions)(options.stackParser || (0, $hgJ38.defaultStackParser)),
        integrations: (0, $fWjB8.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $k6sEr.supportsFetch)() ? (0, $7tbUV.makeFetchTransport) : (0, $jaNts.makeXHRTransport))
    };
    (0, $AcsET.initAndBind)((0, $3DrBT.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $4f8f5dca3b792261$var$startSessionTracking();
}
const $4f8f5dca3b792261$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $duU2C.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $hu6SQ.WINDOW).document) {
        (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $hu6SQ.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $6Svx4.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $hu6SQ.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $hu6SQ.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $hu6SQ.WINDOW).document.head || (0, $hu6SQ.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4f8f5dca3b792261$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4f8f5dca3b792261$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4f8f5dca3b792261$export$4997ffc0176396a6(fn) {
    return (0, $hu6SQ.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4f8f5dca3b792261$var$startSessionTracking() {
    if (typeof (0, $hu6SQ.WINDOW).document === 'undefined') {
        (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $21cRg.startSession)({
        ignoreDuration: true
    });
    (0, $21cRg.captureSession)();
    // We want to create a session for every navigation as well
    (0, $jYHGu.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $21cRg.startSession)({
                ignoreDuration: true
            });
            (0, $21cRg.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4f8f5dca3b792261$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $21cRg.getClient)();
    if (client) client.captureUserFeedback(feedback);
}
module.exports["getDefaultIntegrations"] = $4f8f5dca3b792261$export$5783b2920b1d62b9;

});

parcelRegister("1rIoQ", function(module, exports) {

var $21cRg = parcelRequire("21cRg");

var $fWjB8 = parcelRequire("fWjB8");


var $dRWPa = parcelRequire("dRWPa");

var $erpJl = parcelRequire("erpJl");

var $cLOuA = parcelRequire("cLOuA");

var $jYHGu = parcelRequire("jYHGu");

var $1C9Vl = parcelRequire("1C9Vl");

var $bVNqQ = parcelRequire("bVNqQ");

var $husV7 = parcelRequire("husV7");

var $9Yk75 = parcelRequire("9Yk75");

var $4e32G = parcelRequire("4e32G");

var $7xYxl = parcelRequire("7xYxl");

var $hVeUz = parcelRequire("hVeUz");


var $2FWlS = parcelRequire("2FWlS");


var $hu6SQ = parcelRequire("hu6SQ");

/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $10dac0e9633a2324$var$INTEGRATION_NAME = 'Breadcrumbs';
const $10dac0e9633a2324$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $10dac0e9633a2324$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        setup (client) {
            if (_options.console) (0, $erpJl.addConsoleInstrumentationHandler)($10dac0e9633a2324$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $dRWPa.addClickKeypressInstrumentationHandler)($10dac0e9633a2324$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $1C9Vl.addXhrInstrumentationHandler)($10dac0e9633a2324$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $cLOuA.addFetchInstrumentationHandler)($10dac0e9633a2324$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $jYHGu.addHistoryInstrumentationHandler)($10dac0e9633a2324$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $10dac0e9633a2324$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $10dac0e9633a2324$export$c079d904b326663a = (0, $fWjB8.defineIntegration)($10dac0e9633a2324$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $10dac0e9633a2324$export$2dc68d50d56fbbd = (0, $fWjB8.convertIntegrationFnToClass)($10dac0e9633a2324$var$INTEGRATION_NAME, $10dac0e9633a2324$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $10dac0e9633a2324$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $21cRg.getClient)() !== client) return;
        (0, $21cRg.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $husV7.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $10dac0e9633a2324$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $10dac0e9633a2324$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $10dac0e9633a2324$var$_isEvent(event) ? event.target : event;
            target = (0, $bVNqQ.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $bVNqQ.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $21cRg.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $10dac0e9633a2324$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $hVeUz.severityLevelFromString)(handlerData.level),
            message: (0, $7xYxl.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $7xYxl.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $21cRg.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $10dac0e9633a2324$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $1C9Vl.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $21cRg.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $10dac0e9633a2324$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $21cRg.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $21cRg.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $10dac0e9633a2324$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $21cRg.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $4e32G.parseUrl)((0, $hu6SQ.WINDOW).location.href);
        let parsedFrom = from ? (0, $4e32G.parseUrl)(from) : undefined;
        const parsedTo = (0, $4e32G.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $21cRg.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $10dac0e9633a2324$var$_isEvent(event) {
    return !!event && !!event.target;
}
module.exports["breadcrumbsIntegration"] = $10dac0e9633a2324$export$c079d904b326663a;

});

parcelRegister("9sZl8", function(module, exports) {

var $fWjB8 = parcelRequire("fWjB8");


var $9Yk75 = parcelRequire("9Yk75");


var $2FWlS = parcelRequire("2FWlS");

const $6e464f698cf23b39$var$INTEGRATION_NAME = 'Dedupe';
const $6e464f698cf23b39$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6e464f698cf23b39$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($6e464f698cf23b39$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $6e464f698cf23b39$export$6d39aa44cd0c7567 = (0, $fWjB8.defineIntegration)($6e464f698cf23b39$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6e464f698cf23b39$export$688d98c249d31ad3 = (0, $fWjB8.convertIntegrationFnToClass)($6e464f698cf23b39$var$INTEGRATION_NAME, $6e464f698cf23b39$export$6d39aa44cd0c7567);
function $6e464f698cf23b39$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6e464f698cf23b39$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6e464f698cf23b39$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6e464f698cf23b39$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6e464f698cf23b39$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6e464f698cf23b39$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6e464f698cf23b39$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6e464f698cf23b39$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6e464f698cf23b39$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6e464f698cf23b39$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6e464f698cf23b39$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6e464f698cf23b39$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $6e464f698cf23b39$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $6e464f698cf23b39$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6e464f698cf23b39$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $6e464f698cf23b39$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $6e464f698cf23b39$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}
module.exports["dedupeIntegration"] = $6e464f698cf23b39$export$6d39aa44cd0c7567;

});

parcelRegister("hoz89", function(module, exports) {

var $21cRg = parcelRequire("21cRg");

var $fWjB8 = parcelRequire("fWjB8");


var $iUgAG = parcelRequire("iUgAG");

var $4ybu6 = parcelRequire("4ybu6");

var $bVNqQ = parcelRequire("bVNqQ");

var $jCulH = parcelRequire("jCulH");

var $9Yk75 = parcelRequire("9Yk75");


var $2FWlS = parcelRequire("2FWlS");


var $eRIET = parcelRequire("eRIET");


var $hu6SQ = parcelRequire("hu6SQ");

/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $ca9fedbcf0954906$var$INTEGRATION_NAME = 'GlobalHandlers';
const $ca9fedbcf0954906$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $ca9fedbcf0954906$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ca9fedbcf0954906$var$_installGlobalOnErrorHandler(client);
                $ca9fedbcf0954906$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $ca9fedbcf0954906$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ca9fedbcf0954906$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $ca9fedbcf0954906$export$66acc70e8cf2b71a = (0, $fWjB8.defineIntegration)($ca9fedbcf0954906$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ca9fedbcf0954906$export$204155decbc90e5a = (0, $fWjB8.convertIntegrationFnToClass)($ca9fedbcf0954906$var$INTEGRATION_NAME, $ca9fedbcf0954906$export$66acc70e8cf2b71a);
function $ca9fedbcf0954906$var$_installGlobalOnErrorHandler(client) {
    (0, $iUgAG.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ca9fedbcf0954906$var$getOptions();
        if ((0, $21cRg.getClient)() !== client || (0, $hu6SQ.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $jCulH.isString)(msg) ? $ca9fedbcf0954906$var$_eventFromIncompleteOnError(msg, url, line, column) : $ca9fedbcf0954906$var$_enhanceEventWithInitialFrame((0, $eRIET.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $21cRg.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $ca9fedbcf0954906$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $4ybu6.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ca9fedbcf0954906$var$getOptions();
        if ((0, $21cRg.getClient)() !== client || (0, $hu6SQ.shouldIgnoreOnError)()) return;
        const error = $ca9fedbcf0954906$var$_getUnhandledRejectionError(e);
        const event = (0, $jCulH.isPrimitive)(error) ? $ca9fedbcf0954906$var$_eventFromRejectionWithPrimitive(error) : (0, $eRIET.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $21cRg.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $ca9fedbcf0954906$var$_getUnhandledRejectionError(error) {
    if ((0, $jCulH.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ca9fedbcf0954906$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca9fedbcf0954906$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $jCulH.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $ca9fedbcf0954906$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca9fedbcf0954906$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $jCulH.isString)(url) && url.length > 0 ? url : (0, $bVNqQ.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ca9fedbcf0954906$var$globalHandlerLog(type) {
    (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).log(`Global Handler attached: ${type}`);
}
function $ca9fedbcf0954906$var$getOptions() {
    const client = (0, $21cRg.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
module.exports["globalHandlersIntegration"] = $ca9fedbcf0954906$export$66acc70e8cf2b71a;

});

parcelRegister("6UVdi", function(module, exports) {

var $fWjB8 = parcelRequire("fWjB8");


var $hu6SQ = parcelRequire("hu6SQ");

const $50945a6a94f7a81c$var$INTEGRATION_NAME = 'HttpContext';
const $50945a6a94f7a81c$var$_httpContextIntegration = ()=>{
    return {
        name: $50945a6a94f7a81c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $hu6SQ.WINDOW).navigator && !(0, $hu6SQ.WINDOW).location && !(0, $hu6SQ.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $hu6SQ.WINDOW).location && (0, $hu6SQ.WINDOW).location.href;
            const { referrer: referrer } = (0, $hu6SQ.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $hu6SQ.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $50945a6a94f7a81c$export$1378794447170364 = (0, $fWjB8.defineIntegration)($50945a6a94f7a81c$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $50945a6a94f7a81c$export$5d2ee9a544b09a94 = (0, $fWjB8.convertIntegrationFnToClass)($50945a6a94f7a81c$var$INTEGRATION_NAME, $50945a6a94f7a81c$export$1378794447170364);
module.exports["httpContextIntegration"] = $50945a6a94f7a81c$export$1378794447170364;

});

parcelRegister("2XbcD", function(module, exports) {

var $fWjB8 = parcelRequire("fWjB8");


var $22PUP = parcelRequire("22PUP");


var $eRIET = parcelRequire("eRIET");

const $2269c81e135e40be$var$DEFAULT_KEY = 'cause';
const $2269c81e135e40be$var$DEFAULT_LIMIT = 5;
const $2269c81e135e40be$var$INTEGRATION_NAME = 'LinkedErrors';
const $2269c81e135e40be$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $2269c81e135e40be$var$DEFAULT_LIMIT;
    const key = options.key || $2269c81e135e40be$var$DEFAULT_KEY;
    return {
        name: $2269c81e135e40be$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $22PUP.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $eRIET.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $2269c81e135e40be$export$ebabb00eb7f3a395 = (0, $fWjB8.defineIntegration)($2269c81e135e40be$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2269c81e135e40be$export$8d1e60aaf616fb4f = (0, $fWjB8.convertIntegrationFnToClass)($2269c81e135e40be$var$INTEGRATION_NAME, $2269c81e135e40be$export$ebabb00eb7f3a395);
module.exports["linkedErrorsIntegration"] = $2269c81e135e40be$export$ebabb00eb7f3a395;

});

parcelRegister("crxqs", function(module, exports) {

var $fWjB8 = parcelRequire("fWjB8");


var $fvU8j = parcelRequire("fvU8j");

var $akjeV = parcelRequire("akjeV");


var $hu6SQ = parcelRequire("hu6SQ");

const $90f1ef4dc1abcb9b$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $90f1ef4dc1abcb9b$var$INTEGRATION_NAME = 'TryCatch';
const $90f1ef4dc1abcb9b$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $90f1ef4dc1abcb9b$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $fvU8j.fill)((0, $hu6SQ.WINDOW), 'setTimeout', $90f1ef4dc1abcb9b$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $fvU8j.fill)((0, $hu6SQ.WINDOW), 'setInterval', $90f1ef4dc1abcb9b$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $fvU8j.fill)((0, $hu6SQ.WINDOW), 'requestAnimationFrame', $90f1ef4dc1abcb9b$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $hu6SQ.WINDOW)) (0, $fvU8j.fill)(XMLHttpRequest.prototype, 'send', $90f1ef4dc1abcb9b$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $90f1ef4dc1abcb9b$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($90f1ef4dc1abcb9b$var$_wrapEventTarget);
            }
        }
    };
};
const $90f1ef4dc1abcb9b$export$59bfe9f1c76150e = (0, $fWjB8.defineIntegration)($90f1ef4dc1abcb9b$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $90f1ef4dc1abcb9b$export$f1a018517668e6d3 = (0, $fWjB8.convertIntegrationFnToClass)($90f1ef4dc1abcb9b$var$INTEGRATION_NAME, $90f1ef4dc1abcb9b$export$59bfe9f1c76150e);
function $90f1ef4dc1abcb9b$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $hu6SQ.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $akjeV.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $90f1ef4dc1abcb9b$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $hu6SQ.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $akjeV.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $90f1ef4dc1abcb9b$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $fvU8j.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $akjeV.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $fvU8j.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $akjeV.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $hu6SQ.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $90f1ef4dc1abcb9b$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $hu6SQ.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $fvU8j.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $hu6SQ.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $akjeV.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $hu6SQ.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $akjeV.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $fvU8j.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
module.exports["browserApiErrorsIntegration"] = $90f1ef4dc1abcb9b$export$59bfe9f1c76150e;

});

parcelRegister("7tbUV", function(module, exports) {

var $lOoQm = parcelRequire("lOoQm");


var $6WvWU = parcelRequire("6WvWU");


var $hYyOR = parcelRequire("hYyOR");

/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $57047c544855db8c$export$b2311068c46d7cc8(options, nativeFetch = (0, $hYyOR.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $hYyOR.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $6WvWU.rejectedSyncPromise)(e);
        }
    }
    return (0, $lOoQm.createTransport)(options, makeRequest);
}
module.exports["makeFetchTransport"] = $57047c544855db8c$export$b2311068c46d7cc8;

});

parcelRegister("hYyOR", function(module, exports) {

var $k6sEr = parcelRequire("k6sEr");

var $9Yk75 = parcelRequire("9Yk75");


var $2FWlS = parcelRequire("2FWlS");


var $hu6SQ = parcelRequire("hu6SQ");

let $d1630cae02990d96$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d1630cae02990d96$export$8be2119ce08e3379() {
    if ($d1630cae02990d96$var$cachedFetchImpl) return $d1630cae02990d96$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $k6sEr.isNativeFetch)((0, $hu6SQ.WINDOW).fetch)) return $d1630cae02990d96$var$cachedFetchImpl = (0, $hu6SQ.WINDOW).fetch.bind((0, $hu6SQ.WINDOW));
    const document = (0, $hu6SQ.WINDOW).document;
    let fetchImpl = (0, $hu6SQ.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $2FWlS.DEBUG_BUILD) && (0, $9Yk75.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $d1630cae02990d96$var$cachedFetchImpl = fetchImpl.bind((0, $hu6SQ.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $d1630cae02990d96$export$d499686d2dd738c6() {
    $d1630cae02990d96$var$cachedFetchImpl = undefined;
}
module.exports["getNativeFetchImplementation"] = $d1630cae02990d96$export$8be2119ce08e3379;
module.exports["clearCachedFetchImplementation"] = $d1630cae02990d96$export$d499686d2dd738c6;

});

parcelRegister("jaNts", function(module, exports) {

var $lOoQm = parcelRequire("lOoQm");


var $6WvWU = parcelRequire("6WvWU");

/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $df555405e63989b1$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $df555405e63989b1$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $6WvWU.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $df555405e63989b1$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $lOoQm.createTransport)(options, makeRequest);
}
module.exports["makeXHRTransport"] = $df555405e63989b1$export$5e1441cee30d5a39;

});

parcelRegister("5D2Vi", function(module, exports) {
/**
 * ------------------------------------------------------------------
 * BFF Error Classes
 * Shared error handling for BFF operations / observability
 * ------------------------------------------------------------------
 */ var $92a98ed8f4fcef12$export$7d83cc20f4070394 = /*#__PURE__*/ function(BFFErrorEnum) {
    BFFErrorEnum["BFF_ERROR"] = "BFF_ERROR";
    BFFErrorEnum["BFF_NETWORK_ERROR"] = "BFF_NETWORK_ERROR";
    return BFFErrorEnum;
}({});
class $92a98ed8f4fcef12$export$c6a4f8515f74c5c8 extends Error {
    constructor(message, context){
        super(message);
        this.context = void 0;
        this.originalError = void 0;
        this.status = void 0;
        this.timestamp = void 0;
        this.name = "BFF_ERROR";
        this.context = context.additionalContext;
        this.originalError = context.originalError;
        this.status = context.status;
        this.timestamp = new Date().toISOString();
    }
}
class $92a98ed8f4fcef12$export$f4de77e3e154579c extends $92a98ed8f4fcef12$export$c6a4f8515f74c5c8 {
    constructor(message, context){
        super(message, context);
        this.url = void 0;
        this.name = "BFF_NETWORK_ERROR";
        this.url = context.url;
    }
}
module.exports["BFFErrorEnum"] = $92a98ed8f4fcef12$export$7d83cc20f4070394;
module.exports["BFFError"] = $92a98ed8f4fcef12$export$c6a4f8515f74c5c8;
module.exports["BFFNetworkError"] = $92a98ed8f4fcef12$export$f4de77e3e154579c;

});

parcelRegister("lh3Ec", function(module, exports) {
// Navigation-experience Sentry DSN
const $5f989899057c4a5a$export$6faa4a850bc4d0ce = 'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';
const $5f989899057c4a5a$export$eafddbd5a5d6fa6a = 'afe-navigation-experience';
const $5f989899057c4a5a$export$3a6a639b0dcb30fa = [
    // Browser-level network failures. Newer browsers append the request host, e.g.
    // `Failed to fetch (rovo-extension-web.atlassian.com)`, so allow an optional `(host)` suffix
    // while staying anchored (so e.g. "Failed to fetch universal create menu items" won't match).
    /Failed to fetch(?: \([^)]*\))?$/i,
    // Chromium
    /NetworkError when attempting to fetch/i,
    // Firefox
    /Load failed(?: \([^)]*\))?$/i,
    // Safari
    // Aborted requests. Anchored to the error type (`AbortError: ...`) so FE errors that merely
    // mention "AbortError" in their message are still reported.
    /^AbortError\b/i,
    /The user aborted a request/i,
    // `fetchJSON` failures without a status code (e.g. `fetch() returned no response`).
    /^Failed to fetch data:(?!\s*\d{3}\b)/i,
    /^RelayNetwork: No data returned for operation/i,
    /^FetchError:/i,
    /^Error getting available products by site/i
];
function $5f989899057c4a5a$export$4cbc5d5dee209a6d(message) {
    if (!message) return undefined;
    const match = /^Failed to fetch data:\s*(\d{3})\b/i.exec(message);
    return match ? Number(match[1]) : undefined;
}
const $5f989899057c4a5a$export$d467879341ff009d = 0.01;
function $5f989899057c4a5a$export$223e1d981f020f65(status) {
    if (status === undefined) return 'report';
    if (status === 429) return 'sample';
    if (status === 401 || status === 403 || status >= 500 && status <= 599) return 'suppress';
    return 'report';
}
const $5f989899057c4a5a$export$52d764e0fd2a1dc5 = {
    whitelistUrls: [
        /atl-paas.net/,
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/
    ],
    ignoreUrls: [
        /extensions\//i,
        /^chrome:\/\//i
    ],
    attachStacktrace: true
};
const $5f989899057c4a5a$export$9f448e5ee63d7699 = 'navigation';
module.exports["SENTRY_DSN"] = $5f989899057c4a5a$export$6faa4a850bc4d0ce;
module.exports["SENTRY_TEAM_NAME"] = $5f989899057c4a5a$export$eafddbd5a5d6fa6a;
module.exports["SUPPRESSED_BACKEND_ERROR_PATTERNS"] = $5f989899057c4a5a$export$3a6a639b0dcb30fa;
module.exports["extractHttpStatusFromMessage"] = $5f989899057c4a5a$export$4cbc5d5dee209a6d;
module.exports["RATE_LIMITED_SAMPLE_RATE"] = $5f989899057c4a5a$export$d467879341ff009d;
module.exports["classifyHttpStatus"] = $5f989899057c4a5a$export$223e1d981f020f65;
module.exports["DEFAULT_SENTRY_CONFIG"] = $5f989899057c4a5a$export$52d764e0fd2a1dc5;
module.exports["SENTRY_PRODUCT"] = $5f989899057c4a5a$export$9f448e5ee63d7699;

});

parcelRegister("fAint", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

const $acdb86397111dde9$export$fe188b07687f765a = {
    goalCreate: {
        experienceId: 'uc-goal-create',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    teamCreate: {
        experienceId: 'uc-team-create',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    projectCreate: {
        experienceId: 'uc-project-create',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    universalCreateComponentLoad: {
        experienceId: 'uc-component-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    universalCreatePrefetch: {
        experienceId: 'uc-backend-prefetch',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Operation,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom
        },
        instanceId: undefined
    },
    globalSideNavigationLoad: {
        experienceId: 'global-side-navigation-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    customizationModalLoad: {
        experienceId: 'customization-modal-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    customizationModalUpdate: {
        experienceId: 'customization-modal-update',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Experience,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalMoreMenuLoad: {
        experienceId: 'global-more-menu-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalRootAppChromeLoad: {
        experienceId: 'global-root-app-chrome-load',
        config: {
            type: (0, $gZFfs.ExperienceTypes).Load,
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    }
};
module.exports["NavigationExperienceId"] = $acdb86397111dde9$export$fe188b07687f765a;

});

parcelRegister("9Kv4c", function(module, exports) {

var $3ePvn = parcelRequire("3ePvn");


var $2nIbk = parcelRequire("2nIbk");


var $2kn4K = parcelRequire("2kn4K");

class $56ada1dce007a49c$export$65bd6083489bd8bb extends Error {
    constructor(httpStatus, statusText){
        super(`Failed to fetch data: ${httpStatus} ${statusText}`);
        this.httpStatus = void 0;
        this.httpStatus = httpStatus;
    }
}
function $56ada1dce007a49c$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $56ada1dce007a49c$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $2kn4K.default).packageVersion,
                ...init?.headers
            }
        });
        // Defensive: misbehaving SWs / fetch wrappers can violate the Promise<Response>
        // contract and resolve to undefined
        if (!response) throw new Error('Failed to fetch data: fetch() returned no response');
        // Validate response status and throw an error for non-OK responses, except for specific cases handled by feature flags.
        if (!response.ok) {
            const isAvailableProductsEndpoint = URL.parse(url)?.pathname.includes((0, $2nIbk.BFFEndpointsEnum).AVAILABLE_PRODUCTS);
            // The Available Products endpoint returns a 403 status code exclusively from blockBotsMiddleware.
            if (response.status === 403 && isAvailableProductsEndpoint) // Return an empty list of sites to prevent pollinator from treating this as a failed request.
            return {
                status: (0, $3ePvn.RequestStatus).COMPLETE,
                data: {
                    sites: []
                }
            };
            throw new $56ada1dce007a49c$export$65bd6083489bd8bb(response.status, response.statusText);
        }
        const jsonResponse = await response.json();
        return {
            status: (0, $3ePvn.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $3ePvn.RequestStatus).ERROR,
            error: e,
            ...e instanceof $56ada1dce007a49c$export$65bd6083489bd8bb && {
                httpStatus: e.httpStatus
            },
            data: null
        };
    }
}
module.exports["fetchJSON"] = $56ada1dce007a49c$export$81bec6e38e8b706b;

});

parcelRegister("2nIbk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");


var $8PNRl = parcelRequire("8PNRl");


var $l4e6Y = parcelRequire("l4e6Y");


var $2CYEh = parcelRequire("2CYEh");

var $ac590e61a6089da5$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
const $ac590e61a6089da5$var$getOriginUrl = ({ originUrl: originUrl } = {})=>originUrl || new URL(window.location.href).origin;
const $ac590e61a6089da5$export$3748aab334e7d372 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useURLBuilder(t0) {
    const $ = (0, $bDgLe.c)(20);
    const { cloudId: cloudId, userId: userId, product: product } = t0;
    const { consumer: consumer } = (0, $l4e6Y.useConsumer)();
    const { items: cachedItems } = (0, $8PNRl.useCache)();
    const originUrl = (0, $2CYEh.default)();
    let t1;
    if ($[0] !== cloudId || $[1] !== consumer || $[2] !== originUrl || $[3] !== product || $[4] !== userId) {
        t1 = (props)=>{
            const { product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap } = props;
            const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
            let url;
            try {
                url = new URL(`${$ac590e61a6089da5$var$getOriginUrl({
                    originUrl: originUrl
                })}${baseUrl}`);
            } catch (t2) {
                return "";
            }
            const searchParams = new URLSearchParams();
            const queryParams = [
                [
                    "tenantid",
                    cloudId
                ],
                [
                    "product",
                    productParam || product
                ],
                [
                    "orgid",
                    orgId
                ],
                [
                    "userid",
                    userIdParam || userId
                ],
                [
                    "source",
                    consumer
                ],
                [
                    "locale",
                    locale
                ],
                [
                    "subproduct",
                    subProduct
                ],
                [
                    "d",
                    d
                ],
                [
                    "ro",
                    ro
                ],
                [
                    "rt",
                    rt
                ],
                [
                    "ap",
                    ap
                ]
            ];
            queryParams.forEach((t3)=>{
                const [key, value] = t3;
                if (value) searchParams.append(key, value);
            });
            url.search = searchParams.toString();
            return url.toString();
        };
        $[0] = cloudId;
        $[1] = consumer;
        $[2] = originUrl;
        $[3] = product;
        $[4] = userId;
        $[5] = t1;
    } else t1 = $[5];
    const buildUCMenuItemsURL = t1;
    let t2;
    if ($[6] !== cachedItems || $[7] !== originUrl) {
        t2 = (t3)=>{
            const { baseUrl: baseUrl_0 } = t3;
            const finalBaseUrl = baseUrl_0 ?? "/gateway/api/app-switcher/api/available-products";
            if (cachedItems.length > 0) return "";
            return `${$ac590e61a6089da5$var$getOriginUrl({
                originUrl: originUrl
            })}${finalBaseUrl}?${""}`;
        };
        $[6] = cachedItems;
        $[7] = originUrl;
        $[8] = t2;
    } else t2 = $[8];
    const buildProductShortcutURL = t2;
    let t3;
    if ($[9] !== buildProductShortcutURL || $[10] !== cloudId || $[11] !== consumer || $[12] !== originUrl || $[13] !== product || $[14] !== userId) {
        t3 = (t4)=>{
            const { baseUrl: baseUrl_1 } = t4;
            let url_0 = "";
            if (baseUrl_1) url_0 = `${$ac590e61a6089da5$var$getOriginUrl({
                originUrl: originUrl
            })}${baseUrl_1}`;
            bb39: switch(consumer){
                case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                    url_0 = buildProductShortcutURL({});
                    break bb39;
                case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                    url_0 = buildProductShortcutURL({});
            }
            if (!url_0) return url_0;
            let formattedUrl;
            try {
                formattedUrl = new URL(url_0);
            } catch (t5) {
                return url_0;
            }
            const updatedParams = new URLSearchParams(formattedUrl.search);
            if (consumer) updatedParams.append("source", consumer);
            if (cloudId) updatedParams.append("tenantid", cloudId);
            if (userId) updatedParams.append("userid", userId);
            if (product) updatedParams.append("product", product);
            return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
        };
        $[9] = buildProductShortcutURL;
        $[10] = cloudId;
        $[11] = consumer;
        $[12] = originUrl;
        $[13] = product;
        $[14] = userId;
        $[15] = t3;
    } else t3 = $[15];
    const buildURL = t3;
    let t4;
    if ($[16] !== buildProductShortcutURL || $[17] !== buildUCMenuItemsURL || $[18] !== buildURL) {
        t4 = {
            buildURL: buildURL,
            buildProductShortcutURL: buildProductShortcutURL,
            buildUCMenuItemsURL: buildUCMenuItemsURL
        };
        $[16] = buildProductShortcutURL;
        $[17] = buildUCMenuItemsURL;
        $[18] = buildURL;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : function useURLBuilder({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $l4e6Y.useConsumer)();
    const { items: cachedItems } = (0, $8PNRl.useCache)();
    const originUrl = (0, $2CYEh.default)();
    const buildUCMenuItemsURL = (0, $cozmU.useCallback)((props)=>{
        const { product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap } = props;
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        let url;
        try {
            url = new URL(`${$ac590e61a6089da5$var$getOriginUrl({
                originUrl: originUrl
            })}${baseUrl}`);
        } catch (e) {
            return '';
        }
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer,
        originUrl
    ]);
    const buildProductShortcutURL = (0, $cozmU.useCallback)(({ baseUrl: baseUrl_0 })=>{
        const finalBaseUrl = baseUrl_0 ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${$ac590e61a6089da5$var$getOriginUrl({
            originUrl: originUrl
        })}${finalBaseUrl}?${queryValues}`;
    }, [
        cachedItems,
        originUrl
    ]);
    const buildURL = (0, $cozmU.useCallback)(({ baseUrl: baseUrl_1 })=>{
        let url_0 = '';
        if (baseUrl_1) url_0 = `${$ac590e61a6089da5$var$getOriginUrl({
            originUrl: originUrl
        })}${baseUrl_1}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url_0 = buildProductShortcutURL({});
                break;
            case (0, $3ePvn.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url_0 = buildProductShortcutURL({});
                break;
        }
        if (!url_0) return url_0;
        // Append the consumer to the URL
        let formattedUrl;
        try {
            formattedUrl = new URL(url_0);
        } catch (e_0) {
            return url_0;
        }
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product,
        originUrl
    ]);
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
};
module.exports["BFFEndpointsEnum"] = $ac590e61a6089da5$export$92af951f33a9009c;
module.exports["useURLBuilder"] = $ac590e61a6089da5$export$3748aab334e7d372;

});

parcelRegister("8PNRl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iBJls = parcelRequire("iBJls");

const $e6434da8a9e22a2b$export$c6e89b6bb9436bc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCache() {
    const $ = (0, $bDgLe.c)(18);
    const { value: t0, setValue: setValue } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    const { consumer: consumer, cache: cache, cacheKey: cacheKey } = t0;
    if (!consumer) throw new Error("BFFContext Consumer is not set");
    let t1;
    if ($[0] !== cache || $[1] !== cacheKey) {
        t1 = cache[cacheKey] ?? [];
        $[0] = cache;
        $[1] = cacheKey;
        $[2] = t1;
    } else t1 = $[2];
    const items = t1;
    let t2;
    if ($[3] !== consumer || $[4] !== setValue) {
        t2 = (updatedCacheKey)=>{
            setValue((prev)=>({
                    ...prev,
                    cacheKey: `${consumer}-${updatedCacheKey}`
                }));
        };
        $[3] = consumer;
        $[4] = setValue;
        $[5] = t2;
    } else t2 = $[5];
    const updateCacheKey = t2;
    let t3;
    if ($[6] !== cacheKey || $[7] !== setValue) {
        t3 = (items_0, t4)=>{
            const compareKey = t4 === undefined ? "cloudId" : t4;
            setValue((prev_0)=>{
                const itemData = prev_0.cache[cacheKey] ?? [];
                for (const item of items_0){
                    const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                    if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                    else itemData.push(item);
                }
                return {
                    ...prev_0,
                    cache: {
                        ...prev_0.cache,
                        [cacheKey]: itemData
                    }
                };
            });
        };
        $[6] = cacheKey;
        $[7] = setValue;
        $[8] = t3;
    } else t3 = $[8];
    const addItemsToCache = t3;
    let t4;
    if ($[9] !== cacheKey || $[10] !== setValue) {
        t4 = ()=>{
            setValue((prev_1)=>({
                    ...prev_1,
                    cache: {
                        ...prev_1.cache,
                        [cacheKey]: []
                    }
                }));
        };
        $[9] = cacheKey;
        $[10] = setValue;
        $[11] = t4;
    } else t4 = $[11];
    const clearCache = t4;
    let t5;
    if ($[12] !== addItemsToCache || $[13] !== cacheKey || $[14] !== clearCache || $[15] !== items || $[16] !== updateCacheKey) {
        t5 = {
            addItemsToCache: addItemsToCache,
            cacheKey: cacheKey,
            clearCache: clearCache,
            items: items,
            updateCacheKey: updateCacheKey
        };
        $[12] = addItemsToCache;
        $[13] = cacheKey;
        $[14] = clearCache;
        $[15] = items;
        $[16] = updateCacheKey;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : function useCache() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $cozmU.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $cozmU.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $cozmU.useCallback)((items_0, compareKey = 'cloudId')=>{
        setValue((prev_0)=>{
            const itemData = prev_0.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items_0){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev_0,
                cache: {
                    ...prev_0.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $cozmU.useCallback)(()=>{
        setValue((prev_1)=>({
                ...prev_1,
                cache: {
                    ...prev_1.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        cacheKey: cacheKey,
        clearCache: clearCache,
        items: items,
        updateCacheKey: updateCacheKey
    };
};
module.exports["useCache"] = $e6434da8a9e22a2b$export$c6e89b6bb9436bc0;

});

parcelRegister("l4e6Y", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iBJls = parcelRequire("iBJls");

const $770513d6a7f8dace$export$33062d550933de6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useConsumer() {
    const $ = (0, $bDgLe.c)(2);
    const { value: t0 } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    const { consumer: consumer } = t0;
    let t1;
    if ($[0] !== consumer) {
        t1 = {
            consumer: consumer
        };
        $[0] = consumer;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function useConsumer() {
    const { value: { consumer: consumer } } = (0, $cozmU.useContext)((0, $iBJls.BFFContext));
    return {
        consumer: consumer
    };
};
module.exports["useConsumer"] = $770513d6a7f8dace$export$33062d550933de6f;

});

parcelRegister("2CYEh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $hvBD9 = parcelRequire("hvBD9");

/**
 * Hook that returns the context of a forced origin url (used for supporting global shortcuts locally)
 */ const $bd19be02021d47a6$var$useOriginUrl = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $hvBD9.useBFFOriginUrlContext)();
    return context;
} : ()=>{
    const context = (0, $hvBD9.useBFFOriginUrlContext)();
    return context;
};
var $bd19be02021d47a6$export$2e2bcd8739ae039 = $bd19be02021d47a6$var$useOriginUrl;
module.exports["default"] = $bd19be02021d47a6$export$2e2bcd8739ae039;

});

parcelRegister("hvBD9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $2a49ddf9f8433f3e$var$BFFOriginUrlContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2a49ddf9f8433f3e$export$405f92d0950d3d4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, url: url } = t0;
    let t1;
    if ($[0] !== children || $[1] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a49ddf9f8433f3e$var$BFFOriginUrlContext.Provider, {
            value: url
        }, children);
        $[0] = children;
        $[1] = url;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, url: url })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a49ddf9f8433f3e$var$BFFOriginUrlContext.Provider, {
        value: url
    }, children);
};
const $2a49ddf9f8433f3e$export$13a55721f6e3a9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($2a49ddf9f8433f3e$var$BFFOriginUrlContext);
} : ()=>{
    return (0, $cozmU.useContext)($2a49ddf9f8433f3e$var$BFFOriginUrlContext);
};
module.exports["useBFFOriginUrlContext"] = $2a49ddf9f8433f3e$export$13a55721f6e3a9e;

});

parcelRegister("2kn4K", function(module, exports) {
const $3cf0d34a1b146416$var$packageName = "platform-pkg";
const $3cf0d34a1b146416$var$packageVersion = "0.0.0-use.local";
const $3cf0d34a1b146416$var$_default_1 = {
    packageName: $3cf0d34a1b146416$var$packageName,
    packageVersion: $3cf0d34a1b146416$var$packageVersion
};
var $3cf0d34a1b146416$export$2e2bcd8739ae039 = $3cf0d34a1b146416$var$_default_1;
module.exports["default"] = $3cf0d34a1b146416$export$2e2bcd8739ae039;

});

parcelRegister("hrm0L", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ePvn = parcelRequire("3ePvn");


var $iBJls = parcelRequire("iBJls");

const $49b19f4a84f2889d$export$53cc6abb6942ce72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useStatus() {
    const $ = (0, $bDgLe.c)(20);
    const { setValue: setValue, value: t0, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $iBJls.useBFFContext)();
    const { status: status, error: error } = t0;
    const isInitializing = status === (0, $3ePvn.RequestStatus).INIT;
    const isComplete = status === (0, $3ePvn.RequestStatus).COMPLETE;
    const isError = status === (0, $3ePvn.RequestStatus).ERROR;
    const isLoading = status === (0, $3ePvn.RequestStatus).LOADING;
    const isLoaded = status !== (0, $3ePvn.RequestStatus).LOADING;
    let t1;
    if ($[0] !== currentLoadingRequests.length || $[1] !== setValue || $[2] !== status) {
        t1 = ()=>{
            if (!currentLoadingRequests.length && status === (0, $3ePvn.RequestStatus).LOADING) setValue($49b19f4a84f2889d$var$_temp);
        };
        $[0] = currentLoadingRequests.length;
        $[1] = setValue;
        $[2] = status;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== currentLoadingRequests || $[5] !== setValue || $[6] !== status) {
        t2 = [
            currentLoadingRequests,
            setValue,
            status
        ];
        $[4] = currentLoadingRequests;
        $[5] = setValue;
        $[6] = status;
        $[7] = t2;
    } else t2 = $[7];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[8] !== setValue || $[9] !== updateCurrentLoadingRequests) {
        t3 = (newStatus, integratingComponent, error_0)=>{
            if (newStatus === (0, $3ePvn.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).LOADING);
            if (newStatus === (0, $3ePvn.RequestStatus).COMPLETE) {
                if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).COMPLETE);
            }
            if (newStatus === (0, $3ePvn.RequestStatus).ERROR) {
                if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).ERROR);
            }
            setValue((prev_0)=>{
                const isErrorStatus = newStatus === (0, $3ePvn.RequestStatus).ERROR;
                return {
                    ...prev_0,
                    status: isErrorStatus ? (0, $3ePvn.RequestStatus).ERROR : (0, $3ePvn.RequestStatus).LOADING,
                    error: isErrorStatus ? error_0 : undefined
                };
            });
        };
        $[8] = setValue;
        $[9] = updateCurrentLoadingRequests;
        $[10] = t3;
    } else t3 = $[10];
    const setStatus = t3;
    let t4;
    if ($[11] !== error || $[12] !== isComplete || $[13] !== isError || $[14] !== isInitializing || $[15] !== isLoaded || $[16] !== isLoading || $[17] !== setStatus || $[18] !== status) {
        t4 = {
            error: error,
            isComplete: isComplete,
            isError: isError,
            isInitializing: isInitializing,
            isLoaded: isLoaded,
            isLoading: isLoading,
            setStatus: setStatus,
            status: status
        };
        $[11] = error;
        $[12] = isComplete;
        $[13] = isError;
        $[14] = isInitializing;
        $[15] = isLoaded;
        $[16] = isLoading;
        $[17] = setStatus;
        $[18] = status;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : function useStatus() {
    const { setValue: setValue, value: { status: status, error: error }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $iBJls.useBFFContext)();
    const isInitializing = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $cozmU.useMemo)(()=>status === (0, $3ePvn.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $cozmU.useMemo)(()=>status !== (0, $3ePvn.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $cozmU.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $3ePvn.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $3ePvn.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $3ePvn.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $cozmU.useCallback)((newStatus, integratingComponent, error_0)=>{
        if (newStatus === (0, $3ePvn.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).LOADING);
        if (newStatus === (0, $3ePvn.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $3ePvn.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $3ePvn.RequestStatus).ERROR);
        }
        setValue((prev_0)=>{
            const isErrorStatus = newStatus === (0, $3ePvn.RequestStatus).ERROR;
            return {
                ...prev_0,
                status: isErrorStatus ? (0, $3ePvn.RequestStatus).ERROR : (0, $3ePvn.RequestStatus).LOADING,
                error: isErrorStatus ? error_0 : undefined
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        error: error,
        isComplete: isComplete,
        isError: isError,
        isInitializing: isInitializing,
        isLoaded: isLoaded,
        isLoading: isLoading,
        setStatus: setStatus,
        status: status
    };
};
function $49b19f4a84f2889d$var$_temp(prev) {
    if (prev.status === (0, $3ePvn.RequestStatus).ERROR) return prev;
    return {
        ...prev,
        status: (0, $3ePvn.RequestStatus).COMPLETE
    };
}
module.exports["useStatus"] = $49b19f4a84f2889d$export$53cc6abb6942ce72;

});


//# sourceMappingURL=PageLayout.28c56600.js.map
